import * as THREE from 'three';

export function resizeRenderer(
  renderer: THREE.WebGLRenderer,
  camera: THREE.PerspectiveCamera,
  parent: HTMLElement,
): void {
  renderer.setSize(parent.clientWidth, parent.clientHeight);
  camera.aspect = parent.clientWidth / parent.clientHeight;
  camera.updateProjectionMatrix();
}
